import React, { useState } from 'react';
import { Box, Radio, Stack, Button } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useParams } from 'react-router-dom';

// Example async service function
async function sendPaymentType(paymentType: string, transactionId?: string) {
  // Expect the API to return JSON: { redirect: "some-url" }
  const response = await fetch(`/server/mandate_service/payment-type-selection?payment_type=${paymentType}&reference_id=${transactionId}`);
  if (!response.ok) throw new Error('Failed to fetch payment type selection');
  const data = await response.json();
  // The backend should return { redirect: "url" }
  return data;
}

const paymentTypes = [
  { value: 'debit_order', label: 'Debit Order' },  
  { value: 'card', label: 'Card Payment' },  
];

export default function PaymentTypeSelectPage() {
  const { reference_id } = useParams<{ reference_id?: string }>();
  const [submitting, setSubmitting] = useState(false);

  const form = useForm({
    initialValues: {
      payment_type: '',
    },
    validate: {
      payment_type: (value: string) => (!value ? 'Please select a payment type' : null),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    setSubmitting(true);
    try {
      const data = await sendPaymentType(values.payment_type, reference_id);
      console.log('PRedirect: ', data.redirect);
      if (data && data.redirect) {
        window.location.href = data.redirect;
      }
    } catch (error: any) {
      alert(`Error Payment Selection : ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box maw={400} mx="auto" py="xl">
      <h1>Select Payment Type</h1>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack>
          <Radio.Group
            label="Payment Type"
            required
            {...form.getInputProps('payment_type')}
            error={form.errors.payment_type}
          >
            <Stack mt="xs">
              {paymentTypes.map((type) => (
                <Radio key={type.value} value={type.value} label={type.label} />
              ))}
            </Stack>
          </Radio.Group>
          <Button
            variant="gradient"
            gradient={{ from: "#00ddb3", to: "#00ddb3", deg: 125 }}
            type="submit"
            loading={submitting}
            disabled={submitting}
            loaderProps={{ color: "white" }}
          >
            Continue
          </Button>
        </Stack>
      </form>
    </Box>
  );
}